import React from 'react';
import { Typography, TypographyVariant } from '@secretescapes/falcon';
import { Content, ContentLoading } from './CalendarDayContent.styles';

interface Props {
  day: moment.Moment;
  formattedDay: string;
  price: string;
  isStrikethrough: boolean;
  isLoading: boolean;
}

export const CalendarDayContent = ({
  day,
  formattedDay,
  price,
  isStrikethrough,
  isLoading,
}: Props) => {
  const Container = isLoading ? ContentLoading : Content;

  return (
    <Container>
      <Typography
        dataAttributes={{ testid: `day-${formattedDay}` }}
        color="inherit"
        variant={isStrikethrough ? TypographyVariant.bodyStrikethrough : TypographyVariant.body}
        lineHeight="1"
      >
        {day.format('D')}
      </Typography>
      <Typography
        dataAttributes={{ testid: 'day-price' }}
        color="inherit"
        variant={TypographyVariant.nano}
      >
        {price ? <span translate="no">{price}</span> : <span>&nbsp;</span>}
      </Typography>
    </Container>
  );
};
